import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ProgressClaimReportContent from './progressClaimReportContent';
import addReportWrapper from './reportWrapper';

class ProgressClaimReport extends React.Component {
	render() {
		const report = this.props.report || {};
		
		return (
			<ProgressClaimReportContent report={report} />
		);
	}
}

ProgressClaimReport.propTypes = {
	report: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
	context: state.context
});

export default connect(
	mapStateToProps
)(addReportWrapper(
	ProgressClaimReport, {
		reportUrl: '/api/reports/progress-claim-by-lot',
		downloadUrl: '/Reports/ProgressClaim',
		title: 'Progress Claim',
		className: 'progress-claim-report'
	})
);
